export default __webpack_public_path__ + "static/media/atomic-design-2.61657ce9.webp";